import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

export const GET_PUBLISHERS = "get_publishers";

@Component
export default class PublishersMixin extends Vue {
  index() {
    const path = `${API_ENDPOINT}/special_initiatives/publishers.json`;
    return this.$store.dispatch("http/request", {
      tag: GET_PUBLISHERS,
      url: path,
      method: "GET",
    });
  }
}
